import environment from "environment";
import { Connect } from "./connect";

const HU2113_FORCE_ERROR_SESSION_KEY = "HU2113_FORCE_AMORTIZATION_ERROR";
const HU2113_FORCE_ERROR_HEADER = "x-hu2113-force-error";
const HU2113_FORCE_ERROR_VALUE = "amortization-download";

export type IAmortizationTablePayload = {
  campaignId: number;
  userEmail?: string;
  userIp?: string;
};

export class AmortizationTableConnect extends Connect {
  constructor() {
    const { apiKey, apiMsIntegration } = environment;
    const login = { idToken: sessionStorage.getItem("idToken") };
    super(apiMsIntegration, "", {
      apiKey,
      token: login.idToken ? login.idToken : ""
    });
  }

  async getAmortizationTable(
    payload: IAmortizationTablePayload
  ): Promise<any> {
    const headers: Record<string, string> = {};

    if (payload.userEmail) {
      headers["x-user-email"] = payload.userEmail;
    }

    if (payload.userIp) {
      headers["x-user-ip"] = payload.userIp;
    }

    if (
      sessionStorage.getItem(HU2113_FORCE_ERROR_SESSION_KEY) === "true"
    ) {
      headers[HU2113_FORCE_ERROR_HEADER] = HU2113_FORCE_ERROR_VALUE;
    }

    const response = await this.request({
      method: "get",
      service: `acc-integration/api/v2/campaigns/${payload.campaignId}/amortization-table`,
      headers
    });
    return Promise.resolve(response?.data);
  }
}
